<template>
  <v-container
    fill-height
    fluid
  >
    <v-row justify="center">

      <material-card

        :title="$t('potentialIncidents.create.title')"
        :text="$t('potentialIncidents.create.text')"

      >

        <v-form @submit.prevent="createPotentialIncident">
          <v-container>
            <v-row>


              <v-col cols="12" md="6">
                <v-combobox
                  v-model="workType"
                  :items="workTypes"
                  :item-text="'name'"
                  :item-value="'id'"
                  :label="$t('potentialIncident.workType')"
                  :error-messages="workTypeErrors"
                  required
                  @input="$v.workType.$touch()"
                  @blur="$v.workType.$touch()"

                  @change="getWorkOperations"
                ></v-combobox>
              </v-col>

              <v-col cols="12" md="6">
                <v-combobox
                  v-model="workOperation"
                  :items="workOperations"
                  :error-messages="workOperationErrors"
                  required
                  @input="$v.workOperation.$touch()"
                  @blur="$v.workOperation.$touch()"
                  :item-text="'name'"
                  :item-value="'id'"
                  :label="$t('potentialIncident.workOperation')"

                ></v-combobox>
              </v-col>

              <v-col cols="12" md="6">
                <v-combobox
                  v-model="location"
                  :items="locations"
                  :item-text="'name'"
                  :item-value="'id'"

                  :label="$t('potentialIncident.location')"
                  required
                ></v-combobox>
              </v-col>

              <v-col cols="12" md="6">
                <v-combobox
                  v-model="incidentType"
                  :items="incidentTypes"
                  :error-messages="incidentTypeErrors"
                  required
                  :item-text="'name'"
                  :item-value="'id'"
                  @input="$v.incidentType.$touch()"
                  @blur="$v.incidentType.$touch()"

                  :label="$t('potentialIncident.incidentType')"

                ></v-combobox>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="explanation"
                  :label="$t('potentialIncident.explanation')"

                />

              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="consequenceType"
                  :items="consequenceTypes"
                  :error-messages="consequenceTypeErrors"
                  required
                  :item-text="'name'"
                  :item-value="'id'"
                  @input="$v.consequenceType.$touch()"
                  @blur="$v.consequenceType.$touch()"
                  :label="$t('potentialIncident.consequenceType')"
                ></v-select>
              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="consequence"
                  :items="consequenceStrengths"
                  :error-messages="consequenceErrors"
                  required
                  :item-text="'name'"
                  :item-value="'id'"
                  @input="$v.consequence.$touch()"
                  @blur="$v.consequence.$touch()"
                  :label="$t('potentialIncident.consequence')"
                ></v-select>


              </v-col>


            </v-row>

            <v-expansion-panels multiple popout v-model="openedPanels">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h2 class="font-weight-light mb-4">
                    {{$t('potentialIncident.barriers')}}
                  </h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>

                  <v-row v-for="barrier in barriers">
                    <v-col cols="12" md="8">
                      <v-card >
                        <v-card-title>
                            <v-btn  icon   @click="removeBarrier(barrier.uuid)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>

                        </v-card-title>
                        <v-card-text>
                          <v-col cols="12">
                            <v-text-field
                              v-model="barrier.description"
                              :label="$t('barrier.description')"
                              :error-messages="barrierErrors"
                              required

                            />

                          </v-col>
                          <v-col cols="3" >
                            <v-select
                              v-model="barrier.type"
                              :items="barrierTypes"
                              :item-text="'name'"
                              :item-value="'id'"
                               :error-messages="barrierErrors"
                              required
                              :label="$t('barrier.type')"
                            ></v-select>
                          </v-col>
                          <v-col cols="2">
                            <v-switch v-model="barrier.strength" :label="$t('barrier.strong')"></v-switch>

                          </v-col>
                          <v-col cols="3">
                            <v-combobox
                              v-model="barrier.owner"
                              :items="barrierOwners"
                              :item-text="'name'"
                              :item-value="'id'"
                              :label="$t('barrier.owner')"

                            ></v-combobox>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              v-model="barrier.comment"
                              :label="$t('barrier.comment')"

                            />

                          </v-col>
                        </v-card-text>
                      </v-card>
                    </v-col>


                  </v-row>
                  <v-row>
                    <v-col>

                      <v-btn  icon   @click="addBarrier">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>

                    </v-col>

                  </v-row>


                </v-expansion-panel-content>


              </v-expansion-panel >

              <v-expansion-panel>
                <v-expansion-panel-header>
                  <h2 class="font-weight-light mb-4">
                    {{$t('potentialIncident.measures')}}
                  </h2>
                </v-expansion-panel-header>
                <v-expansion-panel-content>

                  <v-row v-for="measure in measures">

                    <v-col cols="12" md="8">
                      <v-card>
                        <v-card-title>
                          <v-btn icon @click="removeMeasure(measure.uuid)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>

                        </v-card-title>
                        <v-card-text>
                          <v-col cols="12">
                            <v-textarea
                              v-model="measure.measure"
                              :label="$t('measure.measure')"
                              :error-messages="measureErrors"
                              required

                            />

                          </v-col>
                          <v-col cols="12">
                            <v-combobox
                              v-model="measure.measureResponsible"
                              :items="measureResponsibles"
                              :item-text="'name'"
                              :item-value="'id'"
                              :label="$t('measure.measureResponsible')"

                            ></v-combobox>


                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="measure.status"
                              :label="$t('measure.status')"

                            />

                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              v-model="measure.dateClosed"
                              :error-messages="measureErrors"
                              :label="measureClosedLabel"

                            />

                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              v-model="measure.commentOnClosed"
                              :label="$t('measure.commentOnClosed')"

                            />

                          </v-col>


                        </v-card-text>
                      </v-card>
                    </v-col>


                  </v-row>
                  <v-row>
                    <v-col>

                      <v-btn icon @click="addMeasure">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>

                    </v-col>

                  </v-row>


                </v-expansion-panel-content>


              </v-expansion-panel>


            </v-expansion-panels>



            <v-row v-if="calculatedProbability!=''">
              <v-col cols="1" md="3">
                <div class="h2">
                  {{$t('potentialIncident.calculatedProbability')}}:
                </div>
              </v-col>
              <v-col cols="8">
                <div class="h2">
                  {{calculatedProbability}}
                </div>
              </v-col>

            </v-row>

            <v-row v-if="calculatedRisk!=''">
              <v-col cols="1" md="3">
                <div class="h2">
                  {{$t('potentialIncident.calculatedRisk')}}:
                </div>
              </v-col>
              <v-col cols="2">
                <div :class="riskColor">
                  {{calculatedRisk}}
                </div>
              </v-col>

            </v-row>


            <v-row>

              <v-col cols="12" md="6">
                <v-select
                  v-model="consequenceAfterMeasures"
                  :items="consequenceStrengths"
                  :item-text="'name'"
                  :item-value="'id'"
                  :label="$t('potentialIncident.consequenceAfterMeasures')"
                ></v-select>


              </v-col>

              <v-col cols="12" md="6">
                <v-select
                  v-model="probabilityAfterMeasures"
                  :items="probabilityLevels"
                  :item-text="'name'"
                  :item-value="'id'"
                  :label="$t('potentialIncident.probabilityAfterMeasures')"
                ></v-select>
              </v-col>

            </v-row>
            <v-row v-if="calculatedRiskAfterMeasures!=''">
              <v-col cols="1" md="3">
                <div class="h2">
                  {{$t('potentialIncident.calculatedRiskAfterMeasures')}}:
                </div>
              </v-col>
              <v-col cols="2">
                <div
                  :class="riskAfterMeasuresColor">
                  {{calculatedRiskAfterMeasures}}
                </div>
              </v-col>

            </v-row>
            <v-row>
              <v-col
                cols="12"
                class="text-right"
              >
                <v-btn @click.prevent="historyBack">
                  {{$t("global.cancel")}}
                </v-btn>&nbsp;
                <v-btn @click="submit" color="success">
                  {{$t("global.save")}}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </material-card>

    </v-row>
  </v-container>
</template>

<script>

    import api from '../components/backend/backend-api'
    import util from '../utils/util'
    import riskUtil from '../utils/riskutil'
    import {required} from 'vuelidate/lib/validators'
    import moment from 'moment';


    export default {
        data() {
            return {
              measureClosedLabel: this.$i18n.t('measure.dateClosed') + ' (YYYY-MM-DD)',
                openedPanels:[0,1],
                projectId: "",
                workTypes: [],
                workType: "",
                workOperations: [],
                workOperation: "",
                locations: [],
                barrierOwners: [],
              measureResponsibles: [],
                location: "",
                incidentTypes: [],
                incidentType: "",
                consequenceTypes: [],
                consequenceType: "",
                consequence: "",
                measures: [],
                explanation: "",
                consequenceAfterMeasures: "",
                probabilityAfterMeasures: "",
                barriers: [],
                probabilityLevels: [],
                consequenceStrengths: [],
                probability:"",
                calculatedProbability: "",
                calculatedRisk: "",
                calculatedRiskAfterMeasures: "",
                templatePotentialIncidentId: "",
                barrierTypes: []
            }
        },
        validations: {
          barriers: {
            $each : {
              type: {
                required
              },
              description: {
                required
              }

            }
          },
          measures: {
            $each: {
              measure: {
                required
              },
              dateClosed: {
                isDate (value) {
                  if (typeof(value)!='string' || value=='') return true;
                  return moment(value, 'YYYY-MM-DD', true).isValid()
                }
              }
            }
          },
            workType: {
                required
            },
            workOperation: {
                required
            },
            incidentType: {
                required
            },
            consequenceType: {
                required
            },
            consequence: {
                required
            }
        },
        methods: {
            submit() {
                this.$v.$touch()
                if (!this.$v.$invalid) {
                    this.createPotentialIncident()
                }
            },
            createPotentialIncident() {
                api.createPotentialIncident(this.projectId, this.workType, this.workOperation, this.location, this.incidentType, this.consequenceType, this.consequence, this.consequenceAfterMeasures, this.probabilityAfterMeasures, this.barriers, this.measures, this.explanation).then(response => {
                    this.$router.push({path: '/potentialIncidentShow/' + response.id});
                    //   console.log(response.data)
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })


            },
            getWorkTypes(projectId) {
                api.getWorkTypesForProject(projectId).then(response => {
                    this.workTypes = response
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getWorkOperations() {
                this.workOperation = ""
                if (typeof this.workType.id == 'undefined') {
                    this.workOperations = []
                } else {
                    api.getWorkOperations(this.workType.id).then(response => {
                        this.workOperations = response
                    })
                        .catch(error => {
                            this.$store.commit('setErrorMsg', error)
                            console.log(error)
                            //    this.errors.push(error)
                        })
                }
            },
            getIncidentTypes() {
                api.getIncidentTypes().then(response => {
                    this.incidentTypes = response
                    //   console.log(response.data)
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getLocations() {
                api.getLocations().then(response => {
                    this.locations = response
                    //   console.log(response.data)
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getMeasureResponsibles() {
            api.getMeasureResponsibles().then(response => {
              this.measureResponsibles = response
              //   console.log(response.data)
            })
              .catch(error => {
                this.$store.commit('setErrorMsg', error)
                console.log(error)
                //    this.errors.push(error)
              })
          },
            getBarrierOwners() {
                api.getBarrierOwners().then(response => {
                    this.barrierOwners = response
                    //   console.log(response.data)
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getConsequenceTypes() {
                api.getConsequenceTypes().then(response => {
                    this.consequenceTypes = response
                    //   console.log(response.data)
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getProbabilityLevels() {
                api.getProbabilityLevels().then(response => {
                    this.probabilityLevels = response.map(function (strength) {
                        return {'id': strength.strength, 'name': strength.name + ' (' + strength.strength + ')'}
                    })
                    //   console.log(response.data)
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getConsequenceStrengths() {
                api.getConsequenceStrengths().then(response => {
                    this.consequenceStrengths = response.map(function (strength) {
                        return {'id': strength.strength, 'name': strength.name + ' (' + strength.strength + ')'}
                    })
                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            getLevel(obj) {
                if (obj==null || typeof obj != 'object') {
                    return obj;
                } else {
                    return obj.id;
                }
            },
            calculateProbability() {
                api.calculateProbability(this.projectId, this.workType, this.workOperation, this.location, this.incidentType, this.consequenceType, this.consequence, this.consequenceAfterMeasures, this.barriers, this.measures).then(response => {
                    if (response != null) {
                      this.probability = response
                        this.calculatedProbability = response.name + ' (' + response.id + ')'
                        if (this.consequence != undefined)
                            this.calculatedRisk = this.getLevel(this.consequence) * response.id
                    }


                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            },
            calculateRiskAfterMeasures() {
                if (this.consequenceAfterMeasures != "" && this.probabilityAfterMeasures != "") {
                    this.calculatedRiskAfterMeasures = this.getLevel(this.consequenceAfterMeasures )* this.getLevel(this.probabilityAfterMeasures)
                }
            },
            addBarrier() {
                this.barriers.push({
                    "description": "",
                    "type": "",
                    "strength": false,
                    uuid: util.generateUUID(),
                    "owner": "",
                    "comment": ""
                })
            },
            removeBarrier(barrierId) {
                this.barriers = this.barriers.filter(function (ele) {
                    return ele.uuid != barrierId;
                });


            },
            addMeasure() {
                this.measures.push({
                    "measure": "",
                    "measureResponsible": "",
                    "status": "",
                    uuid: util.generateUUID(),
                    "commentOnClosed": "",
                    "dateClosed": null
                })
            },
            removeMeasure(measureId) {
                this.measures = this.measures.filter(function (ele) {
                    return ele.uuid != measureId;
                });


            },
            getPotentialIncident(id) {
                api.getPotentialIncident(id).then(response => {

                    this.projectId = response.projectId
                    this.workType = response.workType
                    this.workOperation = response.workOperation
                    this.location = response.location
                    this.incidentType = response.incidentType
                    this.consequenceType = response.consequenceType
                    this.measures = response.measures
                    this.consequenceAfterMeasures = response.consequenceAfterMeasures
                    this.consequence = response.consequence
                    this.probabilityAfterMeasures = response.probabilityAfterMeasures
                    this.barriers = response.barriers
                    this.probability = response.probability
                    this.calculatedProbability = response.probability.name + ' (' + response.probability.id + ')'
                    this.calculatedRisk = response.risk
                    this.calculatedRiskAfterMeasures = response.riskAfterMeasures
                    this.getWorkTypes(this.projectId)
                    this.explanation =this.$i18n.t('potentialIncidents.create.copy') + ' - '  + response.explanation


                  this.getConsequenceStrengths()
                    this.getProbabilityLevels()

                })
                    .catch(error => {
                        this.$store.commit('setErrorMsg', error)
                        console.log(error)
                        //    this.errors.push(error)
                    })
            }
        },
        mounted() {

            this.getConsequenceStrengths()
            this.getProbabilityLevels()
            this.getIncidentTypes()
            this.getConsequenceTypes()
            this.getLocations()
            this.getBarrierOwners()
            this.getMeasureResponsibles()
            this.barrierTypes = riskUtil.getBarrierTypes()

            if (this.$route.params.templatePotentialIncidentId != undefined) {

                this.templatePotentialIncidentId = this.$route.params.templatePotentialIncidentId
                this.getPotentialIncident(this.$route.params.templatePotentialIncidentId)

            } else {
                this.projectId = this.$route.params.projectId
                this.getWorkTypes(this.projectId)
            }

        },
        computed: {
            workTypeErrors() {
                const errors = []
                if (!this.$v.workType.$dirty) return errors
                !this.$v.workType.required && errors.push(this.$t('validation.required', [this.$t('potentialIncident.workType')]))
                return errors
            },
            workOperationErrors() {
                const errors = []
                if (!this.$v.workOperation.$dirty) return errors
                !this.$v.workOperation.required && errors.push(this.$t('validation.required', [this.$t('potentialIncident.workOperation')]))
                return errors
            },
            incidentTypeErrors() {
                const errors = []
                if (!this.$v.incidentType.$dirty) return errors
                !this.$v.incidentType.required && errors.push(this.$t('validation.required', [this.$t('potentialIncident.incidentType')]))
                return errors
            },
            consequenceTypeErrors() {
                const errors = []
                if (!this.$v.consequenceType.$dirty) return errors
                !this.$v.consequenceType.required && errors.push(this.$t('validation.required', [this.$t('potentialIncident.consequenceType')]))
                return errors
            },
            consequenceErrors() {
                const errors = []
                if (!this.$v.consequence.$dirty) return errors
                !this.$v.consequence.required && errors.push(this.$t('validation.required', [this.$t('potentialIncident.consequence')]))
                return errors
            },
          barrierErrors() {
            const errors = []
            if (!this.$v.barriers.$dirty) return errors
            errors.push(this.$t('validation.barrier.typeAndDescriptionRequired'))
            return errors

          },
          measureErrors() {
            const errors = []
            if (!this.$v.measures.$dirty) return errors
            errors.push(this.$t('validation.measure.measureRequiredAndDateClosedOnIsoFormat'))
            return errors

          },
            barrierTypesCalculated() {
                return this.barriers.map(barrier => barrier.type + barrier.strength)
            },
          riskColor() {
            return riskUtil.getRiskColor(this.probability.id, this.getLevel(this.consequence))
          },
          riskAfterMeasuresColor() {
            return riskUtil.getRiskColor( this.getLevel(this.probabilityAfterMeasures), this.getLevel(this.consequenceAfterMeasures))
          }
        },
        watch: {
            barrierTypesCalculated: function () {
                this.calculateProbability()
            },
            consequence: function () {
                this.calculateProbability()
            },
            consequenceAfterMeasures: function () {
                this.calculateRiskAfterMeasures()
            },
            probabilityAfterMeasures: function () {
                this.calculateRiskAfterMeasures()
            }
        }
    }
</script>
